import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";

import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-disponibilidad",
    templateUrl: "./disponibilidad.component.html",
    styleUrls: ["./disponibilidad.component.scss"],
    animations: fuseAnimations,
})
export class DisponibilidadComponent implements OnInit {
    @Input() comunas: CodigoDTO[];
    @Input() eliminado: boolean;
    @Output() eliminarComuna: EventEmitter<{
        comuna: CodigoDTO;
        nuevasComunas: number[];
        eliminar: boolean;
    }> = new EventEmitter();
    @Output() agregarZonasCobertura: EventEmitter<void> = new EventEmitter();
    constructor(public _menuUsuarioSrvc: MenuUsuarioService) {}

    ngOnInit(): void {}

    eliminar(comuna: CodigoDTO) {
        const nuevasComunas = this.comunas
            .filter((c) => c.id !== comuna.id)
            .map((c) => c.id);

        const data = {
            comuna,
            nuevasComunas,
            eliminar: true,
        };
        this.eliminarComuna.emit(data);
    }

    agregarZonaCobertura() {
        this.agregarZonasCobertura.emit();
    }
}
